// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U5BO","top":"styles_top__2Pe2X","left":"styles_left__3979w","description":"styles_description__1Uznd"};